import styles from './Form.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Form = ({ children, className }) => {
  return <div className={classNames(styles.form, className)}>{children}</div>;
};

Form.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Form.defaultProps = {
  children: null,
  className: null,
};

export default Form;
